/**
 * Created by guga on 8/1/2016.
 */

import {Token} from './token';
import { UserBean }              from '../beansts/index';

export enum AuthStatus {
    Authenticated,
    Unauthenticated
};


export class AuthState {
    public user : UserBean=null;
    constructor(public token : Token, public authStatus : AuthStatus) {}
};


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/sas-models/auth-state.ts